/*
		id: 'id',
		name: 'name',
		type: 'what kind of product',
		service: 'what was done',
		description: 'short discription',
		goal: 'goal description',
		result: 'result description',
		backgroundColor: '#f07252', // f07252
		accentColor: '#a42b2b',
		img: 'print2.png',
		wideImg: true,
		features: [
			{
				title: 'title',
				description: 'description',
				img: 'img.png'
			},
		],
		links: [
			{
				type: 'web',
				url: 'url'
			},
			{
				type: 'ios',
				url: 'url'
			},
			{
				type: 'android',
				url: 'url'
			}
		]
*/

export default [
	{
		id: 'casabela-operacional',
		name: 'Casabela Operacional',
		type: 'Tablet App',
		service: 'Design and Development',
		description: 'A tool as useful as it is elegant',
		goal: 'The Casabela group owns Italinea’s and Todeschini’s chain of custom made furniture. Their Operational Center in Sorocaba, Brazil, needed an app to assist their management and assembly teams, gathering in one tool all the instructions needed to assemble the furniture at their customers place.',
		result: 'Since all the instructions are generated and converted into a PDF file format before being handled to the assembly team on paper, the solution was to create a system where the managers could transfer those files to the assembler’s tablet and the app would perform a search for all the files belonging to the client that would have the furniture installed. Since it is a tool, the app was designed with usability in mind, without letting aside a simple, intuitive and elegant design.',
		backgroundColor: '#e76747', // f07252
		accentColor: '#a42b2b',
		bannerColor: '#f9b09d',
		img: 'casabela-2.png',
		wideImg: true,
		features: [
			{
				title: 'PDF reader to show details no printer can',
				description: 'Working with PDF files, the assembler can zoom in and out without compromising on image quality.',
				img: 'casabela-1.png',
				wideImg: true,
				color: '#f9b09d'
			},
			{
				title: 'Search for every client’s files',
				description: 'Search bar that allows you to find all the files related to the search term.',
				img: 'casabela-2.png',
				wideImg: true,
				color: '#f9b09d'
			},
			{
				title: 'Easy switch between searched files',
				description: 'With one click it is possible to navigate between the searched files without opening the toolbar.',
				img: 'casabela-5.png',
				wideImg: true,
				color: '#f9b09d'
			},
			{
				title: 'Know your assembly team when the tablet is inactive',
				description: 'After the tablet has been inactive for a certain period of time, a screen pops up with a slide show of all the team members so the client can see who is assembling his furniture.',
				img: 'casabela-4.png',
				wideImg: true,
				color: '#f9b09d'
			},
		],
	},
	{
		id: 'ser-arvore-app',
		name: 'Ser Árvore',
		type: 'Mobile App',
		service: 'Design and Development',
		description: 'Harvest your motivational seeds',
		goal: 'Luiz Brites is the author of Ser Árvore, book in wich nature metaphors are used to help readers achieve a better life. Luiz wanted an app that could send daily seeds of new possibilities in the form of notifications to its users.',
		result: 'The app is simple and light, but carries a huge power to aid its users in their lives. Each seed of new possibilities is an image with a quote from the book, which can be saved in the app with the favorites button. The app also features a space where you can find out more about the Ser Árvore book and about the author\'s events.',
		backgroundColor: '#85e747', 
		accentColor: '#23631e',
		bannerColor: '#d0f9a7',
		img: 'ser-arvore-3.jpg',
		wideImg: false,
		features: [
			{
				title: 'Receive daily motivational messages',
				description: 'Based on the metaphors from Luiz\'s book, the images containing the motivational messages are delivered every morning to each user.',
				img: 'ser-arvore-1.jpg',
				wideImg: false,
				color: '#d0f9a7'
			},
			{
				title: 'Save your favorite seeds',
				description: 'The user can save his favorite motivational messages in the favorites section so they can be seem again later.',
				img: 'ser-arvore-2.jpg',
				wideImg: false,
				color: '#d0f9a7'
			},
			{
				title: 'Stay up to date with all the news and harvest your seeds',
				description: 'In the home page there is a banner for all main events Luiz is hosting and also a few more motivational messages users can find at any time.',
				img: 'ser-arvore-3.jpg',
				wideImg: false,
				color: '#d0f9a7'
			},
			{
				title: 'Know more about the book',
				description: 'In case you want to know more about Ser Árvore.',
				img: 'ser-arvore-4.jpg',
				wideImg: false,
				color: '#d0f9a7'
			},
		],
		links: [
			{
				type: 'ios',
				url: 'https://itunes.apple.com/us/app/ser-%C3%A1rvore/id1337010671?mt=8'
			},
			{
				type: 'android',
				url: 'https://play.google.com/store/apps/details?id=com.serarvore'
			}
		]
	}
]


// WEBPACK FOOTER //
// ./src/values/projects/projects-en.js